module.exports = __webpack_public_path__ + "img/mutil-checked.830e8f4d.svg";